import React from 'react';
import { grey } from '@mui/material/colors';
import { SearchOffOutlined } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';

import { GenerateReportBtn } from './GenerateReportBtn';
import { GenerateMockReportBtn } from './GenerateMockReportBtn';

interface Props {
  voId: string;
  isSuperAdmin: boolean;
  isGenerateReportAvailable: boolean;
  generateReportTooltip: string;
}

export const ReportInfoFallback = ({ voId, isSuperAdmin, isGenerateReportAvailable, generateReportTooltip }: Props) => (
  <Stack gap="1rem" alignItems="center">
    <Stack gap="0.5rem" alignItems="center" justifyContent="center" flex={1} py="1rem">
      <Box
        sx={{
          width: '3.5rem',
          height: '3.5rem',
          display: 'flex',
          alignItems: 'center',
          borderRadius: '100%',
          justifyContent: 'center',
          backgroundColor: grey[100],
        }}
      >
        <SearchOffOutlined sx={{ color: grey[500], fontSize: '1.75rem' }} />
      </Box>

      <Typography align="center" variant="h6" component="span">
        No data found
      </Typography>

      <Typography color="textSecondary" align="center">
        No report information is available for this deal.
      </Typography>
    </Stack>

    <Stack alignItems="center" justifyContent="center" gap="1rem" flexDirection="row">
      {isSuperAdmin && (
        <GenerateMockReportBtn voId={voId} tooltip={generateReportTooltip} disabled={!isGenerateReportAvailable} />
      )}

      <GenerateReportBtn voId={voId} disabled={!isGenerateReportAvailable} tooltip={generateReportTooltip} />
    </Stack>
  </Stack>
);
